// extracted by mini-css-extract-plugin
export default {"container":"t","vertical":"u","childrenWithDock":"v"};